import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import he from './locales/he.json';

// The school app ships Hebrew and English only, with its own locale files
// (separate from the consumer app's src/locales) and its own storage key.
const SUPPORTED = ['he', 'en'] as const;
const STORAGE_KEY = 'schoolLng';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      he: { translation: he },
    },
    fallbackLng: 'he',
    supportedLngs: [...SUPPORTED],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      // Default to Hebrew rather than the browser language; switch via LanguageToggle.
      order: ['localStorage'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
    },
  });

export default i18n;
